// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Link from "../Link.bs.js";
import * as React from "react";
import * as ContentSection from "common/src/ContentSection.bs.js";

function SupStarterPack(Props) {
  return React.createElement(ContentSection.make, {
              className: "w-full md:w-[650px] mt-8",
              children: React.createElement("div", {
                    className: "flex items-center"
                  }, React.createElement("div", {
                        className: "w-[100px] text-center mr-8 text-xl font-semibold font-montserrat text-secondary-11"
                      }, "STARTER PACK"), React.createElement("div", {
                        className: "flex flex-col gap-3"
                      }, React.createElement("div", {
                            className: "leading-tight"
                          }, "Once you learn everything about the new set on this page, check out all of the features here on tactics.tools as a study tool!"), React.createElement("div", undefined, "Theorycraft Broken Builds with the ", React.createElement(Link.make, {
                                className: "text-primary-11",
                                route: {
                                  TAG: /* TeamPlanner */3,
                                  _0: undefined
                                },
                                children: "Team Builder"
                              })), React.createElement("div", undefined, "Find Which Units ", React.createElement(Link.make, {
                                className: "text-primary-11",
                                route: {
                                  TAG: /* Info */6,
                                  _0: /* CheatSheet */4
                                },
                                children: "Synergize"
                              }), " With One Another…"), React.createElement("div", undefined, "…", React.createElement(Link.make, {
                                className: "text-primary-11",
                                route: {
                                  TAG: /* Tools */5,
                                  _0: /* PerfectSynergies */1
                                },
                                children: "Perfectly"
                              }), "?"), React.createElement("div", undefined, "Make a ", React.createElement(Link.make, {
                                className: "text-primary-11",
                                route: /* TierList */4,
                                children: "Tier List"
                              }), " to show your friends what is the next broken thing!")))
            });
}

var make = SupStarterPack;

export {
  make ,
  
}
/* Link Not a pure module */
